// Site-wide configuration constants

// LAUNCH_DATE: kept for reference; no longer enforced.
export const LAUNCH_DATE = new Date("2026-07-01T08:00:00+02:00");

// Maintenance mode — set to false to make the public site visible to everyone.
export const MAINTENANCE_MODE = false;
